import { useRouter } from 'next/router';

import { IVariationDetails } from '~/lib/data-contract';
import { isSSR } from '~/shared/utils/platform/utils/platform';
import { useGetRequest } from '~/shared/utils/request/hooks/useGetRequest';

interface IHeadline {
	text?: string;
	level?: number;
}

export interface IUpsellModule {
	headline?: IHeadline;
	brandEffect?: boolean;
	items: IVariationDetails[];
	raptorModule?: string;
	noSpaceAbove?: boolean;
}

export const useUpsellProducts = (moduleId: number) => {
	const router = useRouter();

	// Always use the full path to preserve market/culture context (also on homepage)
	const url = !isSSR ? router.asPath : '';

	return useGetRequest<IUpsellModule>('/api/proxy/content/module', {
		queryKey: ['upsell-products', moduleId, url],
		params: {
			url: url,
			moduleId: moduleId.toString(),
		},
		staleTime: 1000 * 60 * 5, // 5 minutes
		cacheTime: 1000 * 60 * 10, // 10 minutes
	});
};
